
import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const promptExamples = {
  trabalhista: {
    title: "Petição Inicial Trabalhista",
    description: "Gere a estrutura para uma petição inicial trabalhista com base nas informações do caso.",
    prompt: `Você é um advogado trabalhista experiente. 
    Com base nas informações abaixo, elabore uma petição inicial trabalhista bem estruturada:
    
    - Nome do reclamante: [NOME]
    - Qualificação: [QUALIFICAÇÃO]
    - Período trabalhado: [INÍCIO] a [FIM]
    - Função: [FUNÇÃO]
    - Salário: R$ [VALOR]
    - Situação: [DESCREVA O PROBLEMA TRABALHISTA]
    - Pedidos principais: [LISTE OS PEDIDOS]
    
    Utilize linguagem técnica apropriada, estruture corretamente conforme a CLT e inclua os fundamentos jurídicos pertinentes.`
  },
  civel: {
    title: "Contestação Cível",
    description: "Crie um modelo de contestação para ações cíveis com base nos fatos do caso.",
    prompt: `Atue como um advogado especialista em direito civil.
    Elabore uma contestação para a seguinte ação:
    
    - Tipo de ação: [TIPO DA AÇÃO]
    - Número do processo: [NÚMERO]
    - Autor: [NOME DO AUTOR]
    - Réu: [NOME DO RÉU]
    - Resumo da petição inicial: [RESUMO]
    - Principais alegações do autor: [ALEGAÇÕES]
    - Fatos contraditórios: [FATOS]
    - Direito aplicável: [LEIS/JURISPRUDÊNCIAS]
    
    Estruture a contestação com preliminares (se aplicável), mérito, pedidos e conclusão.`
  },
  contratual: {
    title: "Análise de Contrato",
    description: "Análise detalhada de um contrato identificando riscos e sugerindo melhorias.",
    prompt: `Como especialista em direito contratual, analise este contrato:

    [INSIRA O TEXTO DO CONTRATO OU OS PRINCIPAIS PONTOS]
    
    Por favor, forneça:
    1. Identificação de cláusulas potencialmente abusivas
    2. Análise de riscos jurídicos
    3. Verificação de conformidade com: [LEIS APLICÁVEIS]
    4. Sugestões específicas de melhorias
    5. Opinião legal sobre a proteção da parte [CLIENTE]
    
    Organize sua análise em tópicos e sugira redações alternativas para cláusulas problemáticas.`
  }
};

const PromptExamples = () => {
  const [activeTab, setActiveTab] = useState("trabalhista");

  return (
    <section className="py-16 bg-lawyer-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-display mb-4">Exemplos de Prompts</h2>
          <p className="text-gray-600 max-w-xl mx-auto">
            Confira alguns exemplos de prompts disponíveis em nossa plataforma.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Tabs 
            defaultValue="trabalhista" 
            value={activeTab}
            onValueChange={setActiveTab}
            className="w-full"
          >
            <TabsList className="grid grid-cols-3 mb-8">
              <TabsTrigger value="trabalhista">Trabalhista</TabsTrigger>
              <TabsTrigger value="civel">Cível</TabsTrigger>
              <TabsTrigger value="contratual">Contratual</TabsTrigger>
            </TabsList>
            
            {["trabalhista", "civel", "contratual"].map((category) => (
              <TabsContent key={category} value={category}>
                <Card className="border border-gray-200">
                  <CardContent className="p-6">
                    <div className="mb-4">
                      <h3 className="text-xl font-semibold text-lawyer-primary mb-2">
                        {promptExamples[category as keyof typeof promptExamples].title}
                      </h3>
                      <p className="text-gray-600 mb-4">
                        {promptExamples[category as keyof typeof promptExamples].description}
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <p className="text-sm text-gray-700 font-mono whitespace-pre-line">
                        {promptExamples[category as keyof typeof promptExamples].prompt}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default PromptExamples;
